const fileColumns = [
  {
    key: 'file',
    label: 'File'
  },
  {
    key: 'uploaded',
    label: 'Uploaded'
  },
  {
    key: 'action',
    label: ''
  }
];

export default fileColumns;
